<div class="ic-input">
    <label class="ic-input__label" [for]="id" [ngClass]="{
                  'required-field': isRequired
                }">{{ label }}</label>
    <span [ngClass]="{ 'ic-input__subLabel': true, 'wrap-sub-label': wrapSubLabel }" *ngIf="subLabel">
        {{ subLabel }}
    </span>
    <div class="input-wrapper">
        <input [disabled]="disabled" [textMask]="MaskConfig.date" [ngClass]="{
          invalid:
            formGroup?.get(formControlName).invalid &&
            formGroup?.get(formControlName).touched
        }" [value]="formGroup?.get(formControlName).value" container="body"
            (dateSelect)="onChange($event); onDateSelect()" (blur)="onPropagateBlur($event)"
            (input)="onInputChange($event)" class="form-control" [id]="id" placeholder="dd.mm.rrrr" name="dp"
            ngbDatepicker #d="ngbDatepicker" [minDate]="minDateStruct" [maxDate]="maxDateStruct"
            [attr.aria-required]="isRequired"
            [attr.autocomplete]="dynamicAutocomplete"
            [readonly]="isReadonlyHack"
            (focus)="removeReadonlyHack()"
            (mousedown)="removeReadonlyHack()" />
        @if (formGroup?.get(formControlName).value && !disabled) {
        <span (click)="formGroup?.get(formControlName).patchValue(null)" class=" clear material-symbols-outlined">
            close
        </span>
        }
        <button [ngClass]="{
            disabled: disabled,
            invalid:
            formGroup?.controls[formControlName]?.invalid &&
            formGroup?.controls[formControlName]?.touched
        }" (click)="d.toggle()" type="button"><span class="material-icons">
                event
            </span></button>
    </div>
    <div class="error-description-container">
        <div *ngFor="let error of errorList">

            <span *ngIf="onHasOneOfErrors(error.type)" class="error-description">{{ error.label }}</span>
        </div>
    </div>
</div>
